<div class="layout-footer">
    <span class="font-medium ml-2">Champions Webpro &copy; 2024</span>
</div>
